import styled from 'styled-components';

const SortIcon = styled.i.attrs(() => ({
  children: <img src="/assets/img/icons/caret-down-blue.svg" alt="sort" />,
}))`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
`;

export default SortIcon;
